export default __webpack_public_path__ + "static/media/seodex-logo-full.74bfdb90.svg";